import Image from "lib/Image";
import Input from "lib/Input";
import React, { Fragment, useEffect } from "react";
import  classes from "./index.module.scss";
import Search_icon from "assets/images/search_icon.svg";
import PaginationComponent from "lib/Pagination";
import Modal from 'react-bootstrap/Modal';
import { useSelector } from "react-redux";
import  { useState }  from "react";
import { Row,Col } from 'react-bootstrap';
import InviteCustomer from "components/InviteCustomer";
import { setIsUserClicked } from "redux/usersReducer";
import { setActiveStepOrder } from "redux/conditionalRendering";
import { clearRecursiveFormData } from "redux/recursiveReducer";
import { clearSelectedData, setSelectedData } from "redux/formDisplay";
import { useDispatch } from "react-redux";
import { createLinkExpiry } from "api/configuration";
import NoData from "assets/images/NoData.svg";
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Form from 'react-bootstrap/Form';
import CloseButton from 'react-bootstrap/CloseButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { setAllFilterCheckBoxList, setDefaultFilter, setFilterCheckboxList, setPrepopulateDefaultFilter, setSelectedTableSortOptions, setUpdatedDefaultFilter } from "redux/dashboardReducer";
import Label from "lib/Label";
import DynamicForm from "components/DynamicForm";
import FormButton from "components/FormButton";
import { validate } from "components/DynamicForm/validate";
import { checkAndChangeDefault, getDashboardFilters, getFilterDropdownList, updateDashboardFilter } from "api/dashboard";

const TextFilter = (props) => {
  const {
    optionList,
    index,
    item,
    handleRemoveFilter,
    setRemoveFilter
  } = props;

  const [showOptions, setShowOptions] = useState(false);
  const dispatch = useDispatch();
  const selectedFilterCheckboxList = useSelector(state => state.dashboardReducer.selectedFilterCheckboxList);

  const handleClearColumnFilter = (e, id) => {
    e.stopPropagation();
    let selectedFilter = structuredClone(selectedFilterCheckboxList);
    if(selectedFilter?.[id]) {
      delete selectedFilter?.[id];
    }
    let list = {};
    list.value = selectedFilter;
    list.type = id;
    dispatch(setFilterCheckboxList(list));
    setRemoveFilter(selectedFilter);
  }

  useEffect(() => {
    if(Object?.keys(selectedFilterCheckboxList)?.includes(item?.id)) {
      setShowOptions(true);
    } 
  }, [])
  

  return (
    <div key={index}>
      <div
        className={`d-flex justify-content-between my-3 cursor-pointer ${
          !showOptions && "border-bottom border-2"
        }`}
        onClick={() => optionList?.length && setShowOptions(!showOptions)}
      >
        <p className="fs-13px fw-semibold">
          {item?.name}
          <span className="text-muted mx-2">
            {optionList?.length ? `(${optionList?.length})` : "(0)"}
          </span>
        </p>
        <div className="d-flex justify-content-end">
          {optionList?.length ? (
            <p className="fs-13px fw-semibold cursor-pointer" onClick={(e) => handleClearColumnFilter(e, item?.id)}>
              <span className="text-muted mx-2">
                {`Clear(${optionList?.length})`}
              </span>
            </p>
          ) : null}
          {showOptions ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="primary_button"
              class="bi bi-caret-up-fill"
              viewBox="0 0 16 16"
            >
              <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="#E3E4E6"
              class="bi bi-caret-down-fill"
              viewBox="0 0 16 16"
            >
              <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
            </svg>
          )}
        </div>
      </div>
      <div className="">
        {optionList?.length && showOptions
          ? optionList?.map((_item, _index) => {
              return (
                <div
                  className={`d-inline-flex align-items-center mx-1 bg-light p-1 rounded-2 border ${_index} ${_index >= 0 ? 'mb-2':''}`}
                  key={_index}
                >
                  <p className="mb-0 fs-12px mx-2">{_item}</p> 
                  <div onClick={() => handleRemoveFilter(_item, item?.id)} className="cursor-pointer">
                    <svg
                      className="mx-2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-x"
                      viewBox="0 0 16 16"
                    >
                      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                    </svg>
                  </div>
                </div>
              );
            })
          : null}
      </div>
    </div>
  );
}

const SortFilter = (props) => {
  const {
    index,
    item,
    handleApplySort,
    icon
  } = props;

  const selectedTableSortOptions = useSelector(state => state.dashboardReducer.selectedTableSortOptions);

  const handleSort = (id) => {
    if(selectedTableSortOptions?.[id]) {
      let value = selectedTableSortOptions?.[id] || {};
      let data = Object?.keys(value)[0];
      handleApplySort(data, id);
    }
  }

  let aToZSortIcons = {
    "+1": `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sort-alpha-down" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M10.082 5.629 9.664 7H8.598l1.789-5.332h1.234L13.402 7h-1.12l-.419-1.371zm1.57-.785L11 2.687h-.047l-.652 2.157z"/>
              <path d="M12.96 14H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645zM4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293z"/>
            </svg>`,
    "-1": `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sort-alpha-down-alt" viewBox="0 0 16 16">
              <path d="M12.96 7H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645z"/>
              <path fill-rule="evenodd" d="M10.082 12.629 9.664 14H8.598l1.789-5.332h1.234L13.402 14h-1.12l-.419-1.371zm1.57-.785L11 9.688h-.047l-.652 2.156z"/>
              <path d="M4.5 2.5a.5.5 0 0 0-1 0v9.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L4.5 12.293z"/>
            </svg>`
  }

  let updatedSortIcon = {
    "-1": `<svg xmlns="http://www.w3.org/2000/svg" width="16.96" height="14.733" viewBox="0 0 16.96 14.733">
  <g id="Group_49448" data-name="Group 49448" transform="translate(-1292.87 -419.171)">
    <g id="Group_49447" data-name="Group 49447" transform="translate(1300.499 422.584)">
      <path id="Path_55212" data-name="Path 55212" d="M16887.592-20946.475h3" transform="translate(-16890.236 20947.561)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2"/>
      <path id="Path_55213" data-name="Path 55213" d="M16887.588-20946.475h5" transform="translate(-16890.234 20950.561)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.8"/>
      <path id="Path_55214" data-name="Path 55214" d="M16887.588-20946.475h7" transform="translate(-16890.234 20953.561)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.7"/>
      <path id="Path_55215" data-name="Path 55215" d="M16887.59-20946.475h10" transform="translate(-16890.236 20956.561)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.6"/>
      <g id="Group_49449" data-name="Group 49449" transform="translate(-7.629)">
        <path id="Path_55061" data-name="Path 55061" d="M17.585,12.573l-1.258,1.258a.608.608,0,0,1-.88,0l-1.258-1.258a.623.623,0,0,1,.88-.88l.189.189V3.329a.629.629,0,0,1,1.258,0v8.553l.189-.189a.623.623,0,0,1,.88.88Z" transform="translate(-14 -2.7)"/>
      </g>
    </g>
    <text id="N" transform="translate(1309.83 427.171)" font-size="8" font-family="Outfit" font-weight="700"><tspan x="-5" y="0">N</tspan></text>
  </g>
</svg>
`,
    "+1": `<svg xmlns="http://www.w3.org/2000/svg" width="16.96" height="13.587" viewBox="0 0 16.96 13.587">
  <g id="Group_49451" data-name="Group 49451" transform="translate(-1292.87 -422.584)">
    <g id="Group_49447" data-name="Group 49447" transform="translate(1300.499 422.584)">
      <g id="Group_49452" data-name="Group 49452" transform="translate(-2.646 1.086)">
        <path id="Path_55212" data-name="Path 55212" d="M16887.592-20946.475h3" transform="translate(-16887.588 20955.475)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.6"/>
        <path id="Path_55213" data-name="Path 55213" d="M16887.588-20946.475h5" transform="translate(-16887.588 20952.475)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.7"/>
        <path id="Path_55214" data-name="Path 55214" d="M16887.588-20946.475h7" transform="translate(-16887.588 20949.475)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2" opacity="0.8"/>
        <path id="Path_55215" data-name="Path 55215" d="M16887.59-20946.475h10" transform="translate(-16887.588 20946.475)" fill="none" stroke="#000" stroke-linecap="round" stroke-width="1.2"/>
      </g>
      <g id="Group_49449" data-name="Group 49449" transform="translate(-7.629)">
        <path id="Path_55061" data-name="Path 55061" d="M17.585,4.146,16.327,2.889a.608.608,0,0,0-.88,0L14.189,4.146a.623.623,0,0,0,.88.88l.189-.189v8.553a.629.629,0,0,0,1.258,0V4.838l.189.189a.623.623,0,0,0,.88-.88Z" transform="translate(-14 -2.7)"/>
      </g>
    </g>
    <text id="_0" data-name="0" transform="translate(1309.83 434.171)" font-size="8" font-family="Outfit" font-weight="700"><tspan x="-5" y="0">0</tspan></text>
  </g>
</svg>
`
  }

  let selectedIcon = eval(icon);

  return (
    <div
      className={`d-flex justify-content-between my-3 border-bottom border-2 ${selectedTableSortOptions?.[item?.id] && "cursor-pointer"}`}
      key={index}
      onClick={() => selectedTableSortOptions?.[item?.id] && handleSort(item?.id)}
    >
      <p className={`fs-13px fw-semibold ${!selectedTableSortOptions?.[item?.id] && "text-muted"}`}>{item?.name}</p>
      {Object?.keys(selectedTableSortOptions?.[item?.id] || {})?.[0] === "+1" ? (
        <span dangerouslySetInnerHTML={{ __html: selectedIcon?.["+1"] }}></span>
      ) : (
        <span dangerouslySetInnerHTML={{ __html: selectedIcon?.["-1"] }}></span>
      )}
    </div>
  );
}

const SavedFilters = (props) => {
  const {
    setShow,
    saveFilters,
    setSaveFilters,
    module_id
  } = props;

  const dispatch = useDispatch();
  const loggedInInfo = JSON.parse(localStorage.getItem("userToken"));
  const dashboardFilter = useSelector((state) => state?.dashboardReducer?.dashboardFilter);
  const [defaultFound, setDefaultFound] = useState(false);

  const handleOptionClick = (item) => {
    let updatedFilter = [...saveFilters];
    let selectedFilter = updatedFilter?.find((filter) => filter?.checked);
    let selectedIndex = updatedFilter?.findIndex((filter) => filter?.checked);
    let checkedFilter = updatedFilter?.find((filter) => filter?.filter_id === item?.filter_id);
    let checkedIndex = updatedFilter?.findIndex((filter) => filter?.filter_id === item?.filter_id);
    let selected = {...selectedFilter};
    let checked = {...checkedFilter};
    if(selectedIndex === checkedIndex) {
      checked["checked"] = false;
      updatedFilter[checkedIndex] = checked;
    } else {
      selected["checked"] = false;
      checked["checked"] = true;
      updatedFilter[selectedIndex] = selected;
      updatedFilter[checkedIndex] = checked;
    }
    setSaveFilters(updatedFilter);  
  }

  const handleApplyFilter = () => {
    let defaultFilter = saveFilters?.find((item) => item?.checked);
    let params = {
      user_id: loggedInInfo?.userId,
      role_id: loggedInInfo?.role,
      new_default_id: defaultFilter?.filter_id,
      module_id: module_id
    }
    dispatch(checkAndChangeDefault(params))
    .unwrap()
    .then((res) => {
      if(res) {
        let newDefault = res?.filters?.find((item) => item?.is_default);
        if(newDefault) {
          dispatch(setUpdatedDefaultFilter(newDefault));
        } else dispatch(setUpdatedDefaultFilter({}));
        setShow(false);
        window.location.reload();
      }
    })
  }

  useEffect(() => {
    let defaultFilter = saveFilters?.find((item) => item?.is_default);
    if(defaultFilter) setDefaultFound(true);
    else setDefaultFound(false);
  }, []);
  
  return (
    <div className={`${classes['filter-container-height']} d-flex flex-column justify-content-between `}>
      {saveFilters?.length ? (
        <>
          <div className="overflow-y-scroll theme-scrollbar-hover">
            <p className={`${classes['text-primary-grey']} fs-15px m-3 fw-semibold`}>
              Recently used
            </p>
            <Form className="mx-1">
              <div className="border-bottom my-3">
                {saveFilters?.map((item, index) => {
                  if (item?.is_default) {
                    return (
                      <div key={index} onClick={() => handleOptionClick(item)} className="cursor-pointer">
                        <Form.Check
                          type={"radio"}
                          checked={item?.checked}
                          label={item?.filter_name}
                          className={`${classes['bg-grey-light']} py-2 my-3  px-5 fs-13px`}
                        />
                      </div>
                    );
                  }
                })}
                {!defaultFound && (
                  <div className={`${classes['bg-primary-warning']} d-flex align-items-center justify-content-center mx-2 my-3  py-1 rounded-2`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      fill="#D49E05"
                      class="bi bi-exclamation-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                    </svg>
                    <p className= {`${classes['text-warning-search']} fs-13px mx-2 mb-0 mt-1 `}>
                      Default filter not selected.
                    </p>
                  </div>
                )}
              </div>
            </Form>
            <Form className="mx-1">
              <div className="mb-2 pb-3">
                {saveFilters?.map((item, index) => {
                  if (!item?.is_default) {
                    return (
                      <div key={index} onClick={() => handleOptionClick(item)} className="cursor-pointer">
                        <Form.Check
                          type={"radio"}
                          checked={item?.checked}
                          label={item?.filter_name}
                          className={`${classes['bg-grey-light']} py-2  px-5 mb-2 fs-13px`}
                        />
                      </div>
                    );
                  }
                })}
              </div>
            </Form>
          </div>
          <div className="d-flex justify-content-between align-items-center position-sticky bottom-0 bg-white py-2">
            <button
              className="fs-13px light_button"
              onClick={() => setShow(false)}
            >
              Cancel
            </button>
            <button
              className="btn text-white primary_button"
              onClick={handleApplyFilter}
            >
              Apply
            </button>
          </div>
        </>
      ) : (
        <div className={`${classes['not-found']} text-center`}>
          <img
            style={{
              objectFit: "contain",
              width: "70%",
              height: "70%",
            }}
            src={NoData}
            alt="No data found"
          />
          <p>No saved filter. Apply filter to save</p>
          <button
              className={`${classes['apply_filter_button']} fs-13px outline_button `}
              onClick={() => setShow(false)}
            >
              Apply Filter
          </button>
        </div>
      )}
    </div>
  );
}

const Search = (props) => {
  const {
    className,
    value,
    handleSearch,
    handlePageClick,
    pagination,
    Download_icon,
    Filter_icon,
    downloadMISReportByFilter,
    downloadEnable,
    dashboardConfig,
    currentUserRole,
    clearAllFilter,
    setRemoveFilter,
    searchBarConfig,
    filterDropdownList,
    setDefaultTextFilter,
  } = props;

  
  

  const dispatch = useDispatch();
  const loggedInUserInfo = useSelector(state => state.loggedInUserInfo?.userAuthInfo);
  let loading = useSelector((state) => state?.dashboardReducer?.loadingAppplicantDataToDownload);
  const selectedTableSortOptions = useSelector(state => state.dashboardReducer.selectedTableSortOptions);
  const selectedFilterCheckboxList = useSelector(state => state.dashboardReducer.selectedFilterCheckboxList);
  const selectedData = useSelector((state) => state.formData?.selectedData);
  const staticData = useSelector((state) => state.staticData);
  const currentModule = useSelector((state) => state.dashboardReducer?.current_module);
  const [smShow, setSmShow] = useState(false);
  const [invite, setInvite] = useState(false);
  const [toast, setToast] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [key, setKey] = useState('All filters');
  const [saveFilter, setSaveFilter] = useState(false);
  const [formErr, setFormErr] = useState({});
  const [saveFilters, setSaveFilters] = useState([]);
  const loggedInInfo = JSON.parse(localStorage.getItem("userToken"));
  const [showFilter, setShowFilter] = useState(false);
  const filterDetailesFetched = useSelector(state => state.dashboardReducer.filterDetailesFetched);

  // const downloadReportWithFilter =(days) => {
  //   const lastdate = new Date();
  //   lastdate.setDate(lastdate.getDate() - days);
  //   setSmShow(false)
  //   downloadMISReportByFilter(lastdate)
  // }

//   const downloadIcon = `<svg id="noun-download-3465422" xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31">
//   <path id="Path_53898" data-name="Path 53898" d="M254.85,150.991a.5.5,0,0,0,.082.536l3.743,4.226a.515.515,0,0,0,.747,0l3.743-4.226a.5.5,0,0,0-.374-.83h-2.246v-4.509a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,0-.5.5V150.7h-2.246a.5.5,0,0,0-.455.295Z" transform="translate(-243.549 -137.434)" fill="rgba(var(--primary-color),1)"/>
//   <path id="Path_53899" data-name="Path 53899" d="M196,398.258a.749.749,0,0,0,.749.749h12.229a.749.749,0,1,0,0-1.5H196.749A.749.749,0,0,0,196,398.258Z" transform="translate(-187.362 -377.262)" fill="rgba(var(--primary-color),1)"/>
//   <circle id="Ellipse_2135" data-name="Ellipse 2135" cx="15.5" cy="15.5" r="15.5" fill="rgba(var(--primary-color),0.06)"/>
// </svg>`

  const handleRedirect = async () => {
    dispatch(clearSelectedData());
    dispatch(clearRecursiveFormData());
    dispatch(setIsUserClicked(false));
    dispatch(setActiveStepOrder(1));
    if (
      loggedInUserInfo?.organisationInfo?.setting?.link_expiry_duration_in_hours
    ) {
      const linkExpiryObjectID = await dispatch(
        createLinkExpiry({
          organisation_id: loggedInUserInfo?.organisationInfo?._id,
          type: "Invite Customer",
          hours:
            loggedInUserInfo?.organisationInfo?.setting
              ?.link_expiry_duration_in_hours,
        })
      ).unwrap();

      if (linkExpiryObjectID) {
        let redirectURL;
        if (dashboardConfig?.add_customer?.includes("token=")) {
          redirectURL = dashboardConfig?.add_customer.replace(
            /token=[^&]+/,
            linkExpiryObjectID?.data
          );
        } else {
          const separator = dashboardConfig?.add_customer?.includes("?")
            ? "&"
            : "?";
          redirectURL = `${dashboardConfig?.add_customer}${separator}${linkExpiryObjectID?.data}`;
        }
        window.open(`${redirectURL}`, "_blank");
      }
    } else {
      dashboardConfig?.add_customer &&
        window.open(`${dashboardConfig?.add_customer}`, "_blank");
    }
  };
  const handleInviteCustomer = () => {
    setInvite(true);
    setShowModal(true);
  };
  const handleBulkInviteCustomer = () => {
    setInvite(true);
    setShowModal(true);
  };
  
  const closeModal = () => {
    setShowModal(false);
    setInvite(false);
  };
  const setInviteToast = () => {
    setToast(true);
    setTimeout(() => {
      setToast(false);
    }, 3000);
  };
  
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true)

  // const getOptionList = (option, id) => {
  //   let selectedOptions = [];
  //   if(Object?.keys(selectedFilterCheckboxList) && selectedFilterCheckboxList?.[id]) {
  //     Object?.entries(selectedFilterCheckboxList)?.map(([key, value]) => {
  //       if(key === id) {
  //         Object?.entries(value)?.map(([_key,_value]) => {
  //           if(_value) {
  //             let filter = option?.find((item) => item?.id === _key);
  //             selectedOptions = [...selectedOptions, filter?.lable];
  //           }
  //         })
  //       }
  //     })
  //   }
  //   return selectedOptions;
  // }

  // const handleClearFilter = () => {
  //   setShow(false);
  //   clearAllFilter();
  // }

  // const handleRemoveFilter = (option, id) => {
  //   let selectedFilterData = structuredClone(selectedFilterCheckboxList);
  //   let value = filterDropdownList[id]?.value?.find((item) => item?.lable === option);
  //   if (filterDropdownList?.hasOwnProperty(id)) {
  //     if (!selectedFilterData?.hasOwnProperty(id) || selectedFilterData[id] == undefined) {
  //       selectedFilterData[id] = {};
  //       selectedFilterData[id][value?.id] = true;
  //     }else{
  //       if(selectedFilterData?.hasOwnProperty(id)){
  //         selectedFilterData[id][value?.id] = !selectedFilterData[id][value?.id]
  //       }
  //     }
  //   }
  //   let list = {};
  //   list.value = selectedFilterData;
  //   list.type = id;
  //   dispatch(setFilterCheckboxList(list));
  //   setRemoveFilter(selectedFilterData);
  // }

  // const handleApplySort = (data, id) => {
  //   let selectedSortOptions = structuredClone(selectedTableSortOptions);    
  //   if(data === "+1") data = "-1";
  //   else if(data === "-1") data = "+1";
  //   selectedSortOptions[id] = {};
  //   selectedSortOptions[id][data] = true;
  //   dispatch(setSelectedTableSortOptions(selectedSortOptions));
  // }

  // const handleFilter = () => {
  //   if(Object?.keys(selectedFilterCheckboxList)?.length || Object?.keys(selectedTableSortOptions)?.length) setSaveFilter(true);
  // }

  // const clearFieldError = (fields, isList) => {
  //   fields = isList ? fields : [fields];
  //   let err = { ...formErr };
  //   for (let key in fields) {
  //     const _field = fields[key];
  //     if (err[_field] !== undefined) {
  //       delete err[_field];
  //     }
  //   }
  //   setFormErr(err);
  // }

  // const handleSaveFilter = () => {
  //   let params = {
  //     text_filter: selectedFilterCheckboxList,
  //     sort_filter: selectedTableSortOptions,
  //     filter_name: selectedData?.name,
  //     default: selectedData?.default,
  //     user_id: loggedInInfo?.userId,
  //     role_id: loggedInInfo?.role,
  //     organisation_id: loggedInInfo?.userOrg,
  //     configuration_id: dashboardConfig?._id,
  //     module_id: currentModule?.id,
  //   }
  //   dispatch(updateDashboardFilter(params))
  //   .unwrap()
  //   .then((res) => {
  //     if(res) {
  //       setSaveFilter(false);
  //       window.location.reload();
  //     }
  //   })
  // }

  // const validateAndSubmit = async() => {
  //   let validateFields = [];  
  //   formElement?.form_elements.map((item) => {
  //     let fieldVisiblity = false;
  //     if (item.hasOwnProperty("show"))
  //       fieldVisiblity = eval(item?.show);
  //     else fieldVisiblity = true;
  //     if (fieldVisiblity) {
  //       validateFields = [...validateFields, item];
  //     }
  //   });
  //   let errors;
  //   errors = await  validate(validateFields, selectedData, dispatch, staticData);
  //   if(selectedData?.name) {
  //     let findIndex = saveFilters?.findIndex((item) => item?.filter_name === selectedData?.name);
  //     console.log(findIndex)
  //     if (findIndex !== -1) {
  //       errors = {
  //         name: {
  //           err: "Name can't be same."
  //         }
  //       }
  //       setFormErr(errors);
  //     } 
  //   }
  //   let errKeys = Object.keys(errors);
  //   if (errKeys?.length === 0) {
  //     handleSaveFilter();
  //   } else {
  //     setFormErr(errors);
  //   }
  // };

  // const formElement = {
  //   form_elements: [
  //     {
  //       type: "subheader",
  //       name: "filter_label",
  //       sublabel: "Save filter as",
  //       label_style: "mx-2",
  //     },
  //     {
  //       type: "text",
  //       id: "name",
  //       label: "Enter name",
  //       size: "col-lg-12 col-md-12 col-sm-12 ",
  //       name: "name",
  //       placeholder: "Eg: ABC filter",
  //       show: "true",
  //       validators: {
  //         required: true,
  //         pattern: ["^[a-zA-Z0-9][a-zA-Z0-9-/ ]+$"],
  //         min_length: "",
  //         max_length: "25",
  //       },
  //       error_messages: {
  //         min_error: "You have to enter atleast <x> characters",
  //         max_error: "You can't enter more than 25 characters",
  //         pattern_error: "Please enter appropriate name",
  //         required_error: "Required",
  //       },
  //     },
  //     {
  //       type: "checkbox",
  //       id: "default",
  //       label: "Check to make it as default",
  //       size: "col-lg-12 col-md-12 col-12",
  //       name: "default",
  //       show: "true",
  //       options: [
  //         {
  //           label: "Yes",
  //           id: "yes",
  //           for: "yes",
  //         }
  //       ],
  //       validators: {
  //         required: "false",
  //         pattern: [],
  //         min_length: "",
  //         max_length: "",
  //       },
  //       error_messages: {
  //         min_error: "",
  //         max_error: "",
  //         pattern_error: "",
  //         required_error: "This field is mandatory",
  //       },
  //     },
  //   ],
  //   form_buttons: [
  //     {
  //       label: "BACK",
  //       action: "handleBackFilter",
  //     },
  //     {
  //       label: "SAVE",
  //       action: "handleSaveFilter",
  //     },
  //   ],
  // };

  // useEffect(() => {
  //   if(dashboardConfig) {
  //     let headerStructure = dashboardConfig?.header_structure?.list_items;
  //     let filters = headerStructure?.find((item) => item?.type === "filters");
  //     if(filters?.global_filter) {
  //       setShowFilter(true);
  //     } else setShowFilter(false);
  //   }
  // }, [dashboardConfig, currentModule])



  // useEffect(() => {
  //   if(dashboardConfig) {
  //   dispatch(getDashboardFilters({
  //     user_id: loggedInInfo?.userId,
  //     role_id: loggedInInfo?.role,
  //     module_id: currentModule?.id,
  //   }))
  //   .unwrap()
  //   .then(async(res) => {
  //     if(res?.status === "success") {
  //       setSaveFilters(res?.data);
  //       let defaultFilter = res?.data?.find((item) => item?.is_default) || {};
  //       dispatch(setDefaultFilter(defaultFilter));
  //       if(Object?.keys(defaultFilter)?.length) {
  //         let text_filter = defaultFilter?.text_filter;
  //         let sort_filter = defaultFilter?.sort_filter;
  //         let text = {};
  //         let sort = {};
  //         let filterList = filterDropdownList;
  //           await dispatch(getFilterDropdownList({
  //             role_id: loggedInInfo?.role,
  //             module_id: currentModule?.id,
  //             organisation_id: loggedInInfo?.userOrg
  //           }))
  //           .unwrap()
  //           .then((res) => {
  //             filterList = res;
  //             dispatch(setAllFilterCheckBoxList(res));
  //           })
  //         if(Object?.keys(text_filter)?.length && filterList) {
  //           // console.log(filterDropdownList)
  //           Object?.entries(text_filter)?.map(([key, value])=> {
  //             let filter = filterList?.[key]?.value;
  //             let id = [];
  //             if(value?.length) {
  //               value?.map((item) => {
  //                 let filterId = filter?.find((_item) => _item?.lable === item)?.id;
  //                 id.push(filterId);
  //               })
  //             }
  //             let obj = {};
  //             id.map((value) => {
  //               obj[value] = true;
  //             })
  //             text[key] = obj;
  //           })
  //           setDefaultTextFilter(text);
  //           dispatch(setPrepopulateDefaultFilter(text));
  //         }else{
  //           setDefaultTextFilter({});
  //           dispatch(setPrepopulateDefaultFilter({}));
  //         }
  //         if(Object?.keys(sort_filter)?.length) {
  //           Object?.entries(sort_filter)?.map(([key, value])=> {
  //             let obj = {
  //               [value] : true
  //             }
  //             sort[key] = obj;
  //           })
  //           dispatch(setSelectedTableSortOptions(sort));
  //         }else{
  //           dispatch(setSelectedTableSortOptions({}))
  //         }
  //       }else{
  //         dispatch(setPrepopulateDefaultFilter({}));
  //         dispatch(setSelectedTableSortOptions({}));
  //       }

  //     } else {
  //       setSaveFilters([]);
  //       setDefaultTextFilter({});
  //       dispatch(setPrepopulateDefaultFilter({}));
  //       dispatch(setSelectedTableSortOptions({}));
  //     }
  //   })}
  // }, [currentModule])

  return (
    <>
      {invite && (
        <InviteCustomer
          showModal={showModal}
          closeModal={closeModal}
          setInviteToast={setInviteToast}
        />
      )}
      <Row
        className={`${className} border rounded-1 d-flex align-items-center justify-content-between py-1 mx-0 `}
      >
        <Col xs={12} lg={12} className="px-0 d-flex ">
          <div className={`${classes.searchBar} w-300px`}>
            <Image imageSrc={Search_icon} className={`me-2`} />
            <input
              type="text"
              placeholder={
                "Search"
                // searchBarConfig?.placeholder ||
                // "Search for application ID, email address, name, status, PIN"
              }
              className= {`${classes['searchbar_input']} fs-12px pt-1`}
              // value={value}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </div>
        </Col>

        <Col xs={2} md={1} lg={5} xxl={4} className="px-lg-0">
          <div className="d-flex align-items-center justify-content-lg-end">
            <div className="border-end pe-2 d-none d-lg-block">
              {/* <PaginationComponent
                pagination={pagination}
                handlePageClick={handlePageClick}
              /> */}
            </div>
            {/* {downloadEnable ? (
              <>
                {loading ? (
                  <div
                    class="spinner-border text-theme h-25px w-25px fs-13px ms-2 d-none d-lg-block d-md-none d-sm-none"
                    id="download-loader"
                    role="status"
                  >
                    <span class="sr-only">Loading...</span>
                  </div>
                ) : (
                  <button
                    className="download_button h-30px w-30px bg-hover-grey rounded-circle bg-white border-0 mx-2 bg-active-grey"
                    type="button"
                    onClick={(e) => (loading ? {} : setSmShow(true))}
                  >
                    <Image imageSrc={Download_icon} />
                  </button>
                )}
              </>
            ) : (
              ""
            )} */}
            {/* {showFilter && (
              <>
                <button
                  onClick={handleShow}
                  className="d-none d-lg-block d-md-none d-sm-none h-30px w-30px bg-hover-grey rounded bg-white text-dark border-0 mx-2 bg-active-grey"
                >
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15.686"
                      height="15.668"
                      viewBox="0 0 15.686 15.668"
                    >
                      <g
                        id="Group_49398"
                        data-name="Group 49398"
                        transform="translate(-16918.748 21107.332)"
                      >
                        <g
                          id="Group_49398-2"
                          data-name="Group 49398"
                          transform="translate(16902 -21123.082)"
                        >
                          <g
                            id="filter"
                            transform="translate(32.185 16) rotate(90)"
                          >
                            <g
                              id="noun-filter-1721067"
                              transform="translate(0 0)"
                            >
                              <path
                                id="Path_22959"
                                data-name="Path 22959"
                                d="M.986,3.453V.493A.5.5,0,0,0,.493,0,.5.5,0,0,0,0,.493V3.453a.5.5,0,0,0,.493.493A.5.5,0,0,0,.986,3.453Z"
                                transform="translate(1.792)"
                                fill="#515151"
                                stroke="#515151"
                                stroke-width="0.5"
                              />
                              <path
                                id="Path_22960"
                                data-name="Path 22960"
                                d="M.989,9.368v-7.8c0-.36.007-.722,0-1.082V.47A.488.488,0,0,0,.5,0,.49.49,0,0,0,0,.47v7.8C0,8.63,0,8.992,0,9.352v.016a.488.488,0,0,0,.493.47A.49.49,0,0,0,.989,9.368Z"
                                transform="translate(1.789 5.346)"
                                fill="#515151"
                                stroke="#515151"
                                stroke-width="0.5"
                              />
                              <path
                                id="Path_22961"
                                data-name="Path 22961"
                                d="M.493.986h3.6A.5.5,0,0,0,4.585.493.5.5,0,0,0,4.092,0H.493A.5.5,0,0,0,0,.493.5.5,0,0,0,.493.986Z"
                                transform="translate(0 2.959)"
                                fill="#515151"
                                stroke="#515151"
                                stroke-width="0.5"
                              />
                              <path
                                id="Path_22962"
                                data-name="Path 22962"
                                d="M.493.986h3.6A.5.5,0,0,0,4.585.493.5.5,0,0,0,4.092,0H.493A.5.5,0,0,0,0,.493.5.5,0,0,0,.493.986Z"
                                transform="translate(5.274 9.335)"
                                fill="#515151"
                                stroke="#515151"
                                stroke-width="0.5"
                              />
                              <path
                                id="Path_22963"
                                data-name="Path 22963"
                                d="M.989,9.826V1.645c0-.378.007-.757,0-1.135V.493A.5.5,0,0,0,.5,0,.5.5,0,0,0,0,.493V8.674C0,9.052,0,9.432,0,9.81v.016a.5.5,0,0,0,.493.493A.5.5,0,0,0,.989,9.826Z"
                                transform="translate(7.079 0.002)"
                                fill="#515151"
                                stroke="#515151"
                                stroke-width="0.5"
                              />
                              <path
                                id="Path_22964"
                                data-name="Path 22964"
                                d="M.986,3.317V.474A.489.489,0,0,0,.493,0,.491.491,0,0,0,0,.474V3.317a.489.489,0,0,0,.493.474A.491.491,0,0,0,.986,3.317Z"
                                transform="translate(7.082 11.394)"
                                fill="#515151"
                                stroke="#515151"
                                stroke-width="0.5"
                              />
                              <path
                                id="Path_22965"
                                data-name="Path 22965"
                                d="M.988,6.392V1.223c0-.24,0-.48,0-.72V.493A.5.5,0,0,0,.5,0,.5.5,0,0,0,0,.493V5.663c0,.24,0,.48,0,.72v.01A.5.5,0,0,0,.5,6.885a.5.5,0,0,0,.493-.493Z"
                                transform="translate(12.371 0.002)"
                                fill="#515151"
                                stroke="#515151"
                                stroke-width="0.5"
                              />
                              <path
                                id="Path_22966"
                                data-name="Path 22966"
                                d="M.988,6.541V1.216c0-.245,0-.492,0-.737V.469A.487.487,0,0,0,.5,0,.489.489,0,0,0,0,.469V5.793c0,.245,0,.492,0,.737v.011A.487.487,0,0,0,.5,7.009.489.489,0,0,0,.988,6.541Z"
                                transform="translate(12.371 8.175)"
                                fill="#515151"
                                stroke="#515151"
                                stroke-width="0.5"
                              />
                              <path
                                id="Path_22967"
                                data-name="Path 22967"
                                d="M.493.986h3.6A.5.5,0,0,0,4.585.493.5.5,0,0,0,4.092,0H.493A.5.5,0,0,0,0,.493.5.5,0,0,0,.493.986Z"
                                transform="translate(10.582 5.901)"
                                fill="#515151"
                                stroke="#515151"
                                stroke-width="0.5"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </span>
                </button>
                <Offcanvas
                  show={show}
                  onHide={handleClose}
                  placement="end"
                  className="w-25 bg-transparent border-0"
                >
                  <div className="shadow">
                    <Offcanvas.Header closeButton className="bg-white">
                      <Offcanvas.Title className="text-theme fs-17px fw-bold">
                        Filter by
                      </Offcanvas.Title> 
                    </Offcanvas.Header>
                    <Offcanvas.Body className="bg-white">
                      <Tabs
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        id="uncontrolled-tab-example"
                        className="mb-3 border-bottom border-3 position-relative gap-4 search-tab"
                      >
                        <Tab
                          eventKey="All filters"
                          className="fs-15px mx-3"
                          title="All filters"
                        >
                          <div className={`${classes['filter-container-height']} d-flex flex-column justify-content-between`}>
                            <div className="overflow-y-scroll theme-scrollbar-hover pe-2">
                              <div className={`${classes['bg-primary-warning']} d-flex align-items-center justify-content-center mx-2  py-1 rounded-2`}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14"
                                  height="14"
                                  fill="#D49E05"
                                  class="bi bi-exclamation-circle-fill"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                                </svg>
                                <p className={`${classes['text-warning-search']} fs-13px mx-2 mb-0 mt-1 `}>
                                  These are the Columns with filter applied
                                </p>
                              </div>
                              {dashboardConfig?.fields?.map((item, index) => {
                                if (item?.filter_required) {
                                  if (item?.filter_type === "sort") {
                                    return (
                                      <SortFilter
                                        index={index}
                                        item={item}
                                        handleApplySort={handleApplySort}
                                        icon={
                                          item?.id === "full_name"
                                            ? "aToZSortIcons"
                                            : "updatedSortIcon"
                                        }
                                      />
                                    );
                                  } else if (item?.filter_type === "text") {
                                    let optionList =
                                      getOptionList(item?.options, item?.id) ||
                                      [];
                                    return (
                                      <TextFilter
                                        optionList={optionList}
                                        item={item}
                                        index={index}
                                        handleRemoveFilter={handleRemoveFilter}
                                        setRemoveFilter={setRemoveFilter}
                                      />
                                    );
                                  }
                                }
                              })}
                            </div>
                            <div className="d-flex justify-content-between bottom-0 position-sticky bg-white">
                              <button
                                className="btn light_button"
                                onClick={handleClearFilter}
                              >
                                Clear all
                              </button>
                              <button
                                className="primary_button btn text-white"
                                onClick={handleFilter}
                              >
                                Save as
                              </button>
                            </div>
                          </div>
                        </Tab>
                        <Tab eventKey="Saved filters" title="Saved filters">
                          <SavedFilters
                            setShow={setShow}
                            saveFilters={saveFilters}
                            setSaveFilters={setSaveFilters}
                            module_id={currentModule?.id}
                          />
                        </Tab>
                      </Tabs>
                    </Offcanvas.Body>
                  </div>
                </Offcanvas>
              </>
            )} */}
          </div>
        </Col>

        {/* <Modal
          size=""
          show={smShow}
          onHide={() => setSmShow(false)}
          aria-labelledby="example-modal-sizes-title-sm"
        >
          <Modal.Body>
            <Row className="gy-3 gy-lg-0">
              <Col xs={12} md={12} lg={4}>
                <button
                  style={{ border: "none", background: "none" }}
                  type="button"
                  onClick={(e) => downloadReportWithFilter(7)}
                >
                  {" "}
                  <div className="d-flex align-items-center">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: downloadIcon,
                      }}
                    ></span>
                    <p className="mb-0 fs-15px ms-2 mt-1">Last 7 days</p>
                  </div>
                </button>
              </Col>
              <Col xs={12} md={12} lg={4}>
                <button
                  style={{ border: "none", background: "none" }}
                  type="button"
                  onClick={(e) => downloadReportWithFilter(15)}
                >
                  <div className="d-flex align-items-center">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: downloadIcon,
                      }}
                    ></span>
                    <p className="mb-0 fs-15px ms-2 mt-1">Last 15 days</p>
                  </div>
                </button>
              </Col>
              <Col xs={12} md={12} lg={4}>
                <button
                  style={{ border: "none", background: "none" }}
                  type="button"
                  onClick={(e) => downloadReportWithFilter(30)}
                >
                  <div className="d-flex align-items-center">
                    <span
                      dangerouslySetInnerHTML={{
                        __html: downloadIcon,
                      }}
                    ></span>
                    <p className="mb-0 fs-15px ms-2 mt-1">Last 30 Days</p>
                  </div>
                </button>
              </Col>
            </Row>
          </Modal.Body>
        </Modal> */}
      </Row>
      {/* {saveFilter && (
        <>
          <Modal
            className="containermodal mt-1"
            show={saveFilter}
            onHide={() => setSaveFilter(false)}
            centered
            scrollable
            dialogClassName="modal-theme-scrollbar"
          >
            <Modal.Body className="p-4">
              {formElement?.form_elements?.map((item, index) => {
                return (
                  <Fragment key={index}>
                    <DynamicForm
                      formFields={item}
                      formErr={formErr}
                      setFormErr={setFormErr}
                      selectedData={selectedData}
                      setSelectedData={setSelectedData}
                      clearFieldError={clearFieldError}
                    />
                  </Fragment>
                );
              })}
              <FormButton
                formButtons={formElement?.form_buttons}
                handleBackFilter={() => setSaveFilter(false)}
                handleSaveFilter={validateAndSubmit}
              />
            </Modal.Body>
          </Modal>
        </>
      )} */}
    </>
  );
};

export default Search;
